import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight, Check } from "lucide-react";

const INTERESTS = ["Single fish", "Bonded pair", "Ready-to-breed pair", "Not sure yet"];

export function ClownfishWaitlist() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", interest: "Single fish" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.email.trim() || !form.email.includes("@")) return toast.error("Please enter a valid email");
    setBusy(true);
    try {
      await api.post("/clownfish-waitlist", form);
      setDone(true);
      toast.success("You're on the list! We'll text/email you when they drop.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not join the waitlist");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div data-testid="waitlist-success" className="flex items-center gap-3 rounded-2xl border border-cyan/30 bg-cyan/[0.06] px-5 py-4 text-cyan">
        <Check size={20} className="shrink-0" />
        <p className="text-sm">You're on the exotic clownfish waitlist — we'll reach out the moment they're ready. 🐠</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="clownfish-waitlist-form" className="space-y-3">
      <div className="grid sm:grid-cols-2 gap-3">
        <input
          data-testid="waitlist-name" className="er-input" placeholder="Your name"
          value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
        />
        <input
          data-testid="waitlist-email" type="email" required className="er-input" placeholder="Email address *"
          value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
        />
        <input
          data-testid="waitlist-phone" className="er-input" placeholder="Phone (for text alerts)"
          value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })}
        />
        <select
          data-testid="waitlist-interest" className="er-input"
          value={form.interest} onChange={(e) => setForm({ ...form, interest: e.target.value })}
        >
          {INTERESTS.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
      </div>
      <button
        type="submit" disabled={busy} data-testid="waitlist-submit"
        className="btn-pill btn-solid inline-flex items-center gap-2 disabled:opacity-50"
      >
        {busy ? "Joining…" : <>Notify me when Nemos drop <ArrowRight size={15} /></>}
      </button>
    </form>
  );
}
